import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { BRAND } from "../lib/api";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="bg-charcoal text-ivory">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-3">
              <span className="font-heading text-3xl tracking-tight">Tenjara</span>
              <span className="overline text-gold">Lombok</span>
            </div>
            <p className="mt-5 text-ivory/70 max-w-md font-light leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-ivory/50">{t("nav.projects")}</div>
            <ul className="mt-5 space-y-3 text-sm text-ivory/80 font-light">
              <li><a href="#about" className="hover:text-gold transition-colors">{t("nav.about")}</a></li>
              <li><a href="#projects" className="hover:text-gold transition-colors">{t("nav.projects")}</a></li>
              <li><a href="#guide" className="hover:text-gold transition-colors">{t("nav.guide")}</a></li>
              <li><a href="#contact" className="hover:text-gold transition-colors">{t("nav.contact")}</a></li>
              <li>
                <Link
                  to="/admin/login"
                  data-testid="footer-admin-link"
                  className="hover:text-gold transition-colors"
                >
                  {t("nav.admin")}
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="overline text-ivory/50">{t("contact.channels")}</div>
            <ul className="mt-5 space-y-3 text-sm text-ivory/80 font-light">
              <li>
                <a href={`mailto:${BRAND.email}`} className="hover:text-gold transition-colors">
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="hover:text-gold transition-colors">
                  {BRAND.phone}
                </a>
              </li>
              <li className="text-ivory/60">{BRAND.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-ivory/15 flex flex-wrap items-center justify-between gap-4 text-xs text-ivory/50 tracking-[0.15em] uppercase font-medium">
          <div>© {year} Tenjara Lombok. {t("footer.rights")}</div>
          <div>Lombok · Indonesia</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
